import React, { Component } from "react";
import FormatDialog from "../../components/structure/FormatDialog";
import { languages } from "../../constants/languages";
import "../../components/structure/NoStructureMessage.css";
import { withTheme } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import { nextPouleName } from "../../util/NextPouleName";
import Poule3Matches from "../../constants/Poule3Matches";
import Poule4Matches from "../../constants/Poule4Matches";
import Poule5Matches from "../../constants/Poule5Matches";
import Poule6Matches from "../../constants/Poule6Matches";
var robin = require("roundrobin");
const group = require("../../img/group.png");
const groupknockout = require("../../img/groupknockout.png");
const knockout = require("../../img/knockout.png");

class FormatContainer extends Component {
  state = {
    structure: null,
    numPoules: 4,
    pouleSize: "4",
    numToKO: 8,
  };

  handleStructureClick = (e, structure) => {
    e.preventDefault();
    if ((this.props.tournamentStatus || {}).closed) {
      this.props.toggleFinishedDialog();
    } else {
      this.setState({ structure: structure });
    }
  };

  handleClose = (e) => {
    e.preventDefault();
    this.setState({ structure: null });
  };

  handleChange = (event) => {
    let newState = {};
    newState[event.target.name] = event.target.value;
    this.setState(newState);
  };

  handleSubmit = (e) => {
    e.preventDefault();
    let tournamentVrsn = this.props.tournament.vrsn;
    let makePoules = false;
    if (this.state.structure === 0 || this.state.structure === 1) {
      makePoules = true;
    }
    let makeBracket = false;
    if (this.state.structure === 1 || this.state.structure === 2) {
      makeBracket = true;
    }

    let fases = [
      {
        name: makePoules
          ? languages.structure.groupFase
          : languages.structure.knockoutFase,
        started: true,
      },
    ];

    if (makePoules && makeBracket) {
      fases.push({
        name: languages.structure.knockoutFase,
        started: false,
      });
    }
    const db = window.firebase.firestore();
    db.collection("tournaments")
      .doc(this.props.tournament[".key"])
      .collection("divisions")
      .doc(this.props.division.id)
      .update({ fases: fases });

    // reset scoretypes for phase
    let scoringTypesPerDivisionPerPhase =
      this.props.tournament.scoringTypesPerDivisionPerPhase || {};
    if (scoringTypesPerDivisionPerPhase[this.props.division.id]) {
      delete scoringTypesPerDivisionPerPhase[this.props.division.id];
      db.collection("tournaments")
        .doc(this.props.tournament[".key"])
        .update({
          scoringTypesPerDivisionPerPhase: scoringTypesPerDivisionPerPhase,
        });
    }

    let lastNum = -1;
    let lastLetter = "";
    let lastNumOnline = -1;
    let lastLetterOnline = "";
    if (makePoules) {
      for (let num = 0; num < this.state.numPoules; num++) {
        lastNum = num;
        lastNumOnline = num;

        const poule = {
          name: "",
          pouleSize: this.state.pouleSize,
          doubleMatches: false,
          division: this.props.division.id,
          fase: 0,
          bracket: null,
          num: num,
        };

        const db = window.firebase.firestore();
        let batch = db.batch();

        var pouleRef = db
          .collection("tournaments")
          .doc(this.props.tournament[".key"])
          .collection("poules");
        let nextLetter = nextPouleName(lastLetter);
        poule["letter"] = nextLetter;
        if (tournamentVrsn >= 6) {
          poule["numOnline"] = lastNumOnline;
        }
        lastLetter = nextLetter;
        poule["name"] =
          languages.structure.poule +
          " " +
          (this.props.tournament.online && tournamentVrsn >= 6
            ? (poule.numOnline + 1).toString()
            : poule.letter);

        pouleRef = pouleRef.doc();
        batch.set(pouleRef, poule);
        batch = this.makeMatches(batch, pouleRef.id);
        batch = this.makeResultSpots(batch, pouleRef.id, 0);
        batch.commit();
      }
    }

    if (makeBracket) {
      const bracket = {
        name: "",
        size: this.state.numToKO,
        division: this.props.division.id,
        fase: makePoules ? 1 : 0,
      };
      bracket["num"] = lastNum + 1;
      bracket["letter"] = nextPouleName(lastLetter);
      if (tournamentVrsn >= 6) {
        bracket["letterOnline"] = nextPouleName(lastLetterOnline);
      }
      bracket["name"] =
        languages.structure.bracket +
        " " +
        (this.props.tournament.online && tournamentVrsn >= 6
          ? bracket.letterOnline
          : bracket.letter);

      const db = window.firebase.firestore();
      let batch = db.batch();

      var bracketRef = db
        .collection("tournaments")
        .doc(this.props.tournament[".key"])
        .collection("brackets");
      bracketRef = bracketRef.doc();
      batch.set(bracketRef, bracket);
      batch = this.makePoules(
        batch,
        bracketRef.id,
        this.props.tournament.online && tournamentVrsn >= 6
          ? bracket["letterOnline"]
          : bracket["letter"],
        bracket.fase,
        lastNum
      );
      batch.commit();
    }

    if (this.props.tournament.ia) {
      const db = window.firebase.firestore();
      let batch = db.batch();
      batch.set(db.collection("cacheUpdatesApp").doc(), {
        tournamentId: this.props.tournament[".key"],
        status: "pending",
        timestamp: window.firebase.firestore.FieldValue.serverTimestamp(),
      });
      batch.commit();
    }
  };

  makePoules = (batch, bracketId, bracketLetter, fase = 0, lastNum) => {
    let round = 2;
    let pouleNum = lastNum + this.state.numToKO;
    let matchNum = this.state.numToKO;

    let poulesPerRound = {};

    while (round <= this.state.numToKO) {
      poulesPerRound[round] = {};

      const poule = {
        pouleSize: "2",
        doubleMatches: false,
        division: this.props.division.id,
        fase: fase,
        bracket: bracketId,
        singleMatch: true,
        bracketRound: round,
      };

      const db = window.firebase.firestore();

      let fromNum = round - 2;
      if (round === 2) {
        fromNum = 2;
      }

      for (let i = fromNum; i >= 0; i -= 2) {
        var pouleRef = db
          .collection("tournaments")
          .doc(this.props.tournament[".key"])
          .collection("poules");
        poule["name"] =
          languages.structure.matchCapital +
          " " +
          bracketLetter +
          matchNum.toString();
        poule["num"] = pouleNum;

        if (round === 2) {
          if (i === 2) {
            poule["losersFinal"] = true;
          } else {
            poule["losersFinal"] = false;
          }
        }

        pouleRef = pouleRef.doc();
        batch.set(pouleRef, poule);
        batch = this.makeMatchesBracket(batch, pouleRef.id, bracketId);

        let winnerToPoule = undefined;
        let winnerToNumInPoule = undefined;
        let loserToPoule = undefined;
        let loserToNumInPoule = undefined;
        if (round > 2) {
          const nextRound = poulesPerRound[round / 2];
          if (i % 4 === 0) {
            winnerToPoule = nextRound[i / 2];
            winnerToNumInPoule = 0;
            // losers final
            if (round === 4) {
              loserToPoule = nextRound[2];
              loserToNumInPoule = 0;
            }
          } else {
            winnerToPoule = nextRound[(i - 2) / 2];
            winnerToNumInPoule = 1;
            // losers final
            if (round === 4) {
              loserToPoule = nextRound[2];
              loserToNumInPoule = 1;
            }
          }
        }

        batch = this.makeResultSpotsBracket(
          batch,
          pouleRef.id,
          poule.num,
          winnerToPoule,
          winnerToNumInPoule,
          loserToPoule,
          loserToNumInPoule,
          bracketId,
          round,
          fase
        );

        poulesPerRound[round][i] = pouleRef.id;

        matchNum--;
        pouleNum--;
      }

      round = round * 2;
    }
    return batch;
  };

  makeMatchesBracket = (batch, pouleId, bracketId) => {
    let teams = [];
    for (let i = 0; i < 2; i++) {
      teams.push({
        id: i,
      });
    }
    const db = window.firebase.firestore();

    const matchesRef = db
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .collection("matches");

    let rounds = robin(teams.length, teams);
    let num = 0;
    let roundNum = 0;
    for (let i in rounds) {
      let round = rounds[i];
      for (let j in round) {
        let match = round[j];
        let newMatch = {
          round: roundNum,
          poule: pouleId,
          bracket: bracketId,
          numInPoule: num,
          team1: match[0].id,
          team2: match[1].id,
          score1: null,
          score2: null,
          field: null,
        };
        num++;
        const newRef = matchesRef.doc();
        batch.set(newRef, newMatch);
      }
      roundNum++;
    }

    return batch;
  };

  makeMatches = (batch, pouleId) => {
    let teams = [];
    for (let i = 0; i < this.state.pouleSize; i++) {
      teams.push({
        id: i,
      });
    }
    const db = window.firebase.firestore();

    const matchesRef = db
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .collection("matches");

    let rounds = robin(teams.length, teams);
    let useSpecialOrder = false;
    if (this.state.pouleSize === "3") {
      rounds = Poule3Matches;
      useSpecialOrder = true;
    } else if (this.state.pouleSize === "4") {
      rounds = Poule4Matches;
      useSpecialOrder = true;
    } else if (this.state.pouleSize === "5") {
      rounds = Poule5Matches;
      useSpecialOrder = true;
    } else if (this.state.pouleSize === "6") {
      rounds = Poule6Matches;
      useSpecialOrder = true;
    }
    let num = 0;
    let roundNum = 0;
    for (let i in rounds) {
      let round = rounds[i];
      for (let j in round) {
        let match = round[j];
        let newMatch = {
          round: roundNum,
          poule: pouleId,
          numInPoule: num,
          team1: useSpecialOrder ? match[0] - 1 : match[0].id,
          team2: useSpecialOrder ? match[1] - 1 : match[1].id,
          score1: null,
          score2: null,
          field: null,
        };
        num++;
        const newRef = matchesRef.doc();
        batch.set(newRef, newMatch);
      }
      roundNum++;
    }

    return batch;
  };

  makeResultSpotsBracket = (
    batch,
    pouleId,
    pouleNum,
    winnerToPoule,
    winnerToNumInPoule,
    loserToPoule,
    loserToNumInPoule,
    bracketId,
    bracketRound,
    fase = 0
  ) => {
    const db = window.firebase.firestore();

    const resultSpotsRef = db
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .collection("resultSpots");

    // delete old result spots
    if (this.props.resultSpotsNotDivided) {
      for (let x in this.props.resultSpotsNotDivided) {
        let oldResultSpot = this.props.resultSpotsNotDivided[x];
        batch.delete(resultSpotsRef.doc(oldResultSpot.id));
      }
    }

    for (let i = 0; i < 2; i++) {
      let resultSpot = {
        fromPoule: pouleId,
        fromPouleNum: pouleNum,
        rank: i,
        type: 0,
        fase: fase,
        division: this.props.division.id,
        belongsToBracket: bracketId,
        bracketRound: bracketRound,
      };
      if (
        winnerToPoule !== undefined &&
        winnerToNumInPoule !== undefined &&
        i === 0
      ) {
        resultSpot["poule" + fase] = winnerToPoule;
        resultSpot["numInPoule" + fase] = winnerToNumInPoule;
      }

      if (
        loserToPoule !== undefined &&
        loserToNumInPoule !== undefined &&
        i === 1
      ) {
        resultSpot["poule" + fase] = loserToPoule;
        resultSpot["numInPoule" + fase] = loserToNumInPoule;
      }

      let newRef = resultSpotsRef.doc();

      batch.set(newRef, resultSpot);
    }

    return batch;
  };

  makeResultSpots = (batch, pouleId, fase = 0) => {
    const db = window.firebase.firestore();

    const resultSpotsRef = db
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .collection("resultSpots");

    for (let i = 0; i < this.state.pouleSize; i++) {
      let resultSpot = {
        fromPoule: pouleId,
        rank: i,
        type: 0,
        fase: fase,
        division: this.props.division.id,
      };
      let newRef = resultSpotsRef.doc();

      batch.set(newRef, resultSpot);
    }

    return batch;
  };

  render() {
    return (
      <div>
        <FormatDialog
          open={this.state.structure !== null}
          handleClose={this.handleClose}
          {...this.state}
          handleChange={this.handleChange}
          handleSubmit={this.handleSubmit}
          tournament={this.props.tournament}
        />
        <div
          className="container"
          style={{ display: "inline-block", margin: "15px 15px 0 15px" }}
          onClick={(e) => {
            this.handleStructureClick(e, 0);
          }}
        >
          <Typography>{languages.structure.onlyGroup}</Typography>
          <img className="image" src={group} alt="" style={{ width: 300 }} />
          <div
            className="middle"
            style={{ backgroundColor: this.props.theme.palette.primary.main }}
          >
            <Typography
              variant="button"
              className="text"
              style={{ color: "white" }}
            >
              {languages.structure.onlyGroup}
            </Typography>
          </div>
        </div>
        <div
          className="container"
          style={{ display: "inline-block", margin: "15px 15px 0 15px" }}
          onClick={(e) => {
            this.handleStructureClick(e, 1);
          }}
        >
          <Typography>{languages.structure.groupKO}</Typography>
          <img
            className="image"
            src={groupknockout}
            alt=""
            style={{ width: 300 }}
          />
          <div
            className="middle"
            style={{ backgroundColor: this.props.theme.palette.primary.main }}
          >
            <Typography
              variant="button"
              className="text"
              style={{ color: "white" }}
            >
              {languages.structure.groupKO}
            </Typography>
          </div>
        </div>
        <div
          className="container"
          style={{ display: "inline-block", margin: "15px 15px 0 15px" }}
          onClick={(e) => {
            this.handleStructureClick(e, 2);
          }}
        >
          <Typography>{languages.structure.onlyKO}</Typography>
          <img className="image" src={knockout} alt="" style={{ width: 300 }} />

          <div
            className="middle"
            style={{ backgroundColor: this.props.theme.palette.primary.main }}
          >
            <Typography
              variant="button"
              className="text"
              style={{ color: "white" }}
            >
              {languages.structure.onlyKO}
            </Typography>
          </div>
        </div>
      </div>
    );
  }
}

export default withTheme(FormatContainer);
